<template>
	<div class="en_con">
		<div class="en_con_pc" v-if="!isPhone">
			<div class="bn_img">
				<img src="@/images/contact/img2.png">
			</div>
			<div class="ct_con flex1">
				<div class="cton_left">Contact us</div>
				<div class="cton_right">
					<div class="crt_dx1">We are committed to providing you with better products and services. If you have any inquiries, feel free to contact us through the channels below, and we will get back to you as soon as possible!</div>
					<div class="crt_dx2 flex3">
						<img src="@/images/contact/icon_2.png">
						<span class="crt_dx2_tx1"></span>
						<span class="crt_dx2_tx2">Email：export@jnc.cn</span>
					</div>
					<div class="crt_dx2 flex3">
						<img src="@/images/contact/icon_3.png">
						<span class="crt_dx2_tx1"></span>
						<span class="crt_dx2_tx2">Address：No. 289 Chunyi Street, Mianzhu City, Sichuan Province</span>
					</div>
				</div>
			</div>
		</div>
		<div class="en_con_phone" v-if="isPhone">
			<enHeader2 :searchShow="true"></enHeader2>
			<div class="bn_img">
				<img src="@/images/contact/img11.png">
			</div>
            <div class="lx_sty2">
                <span>Contact us</span>
            </div>
			<div class="cont_text">
				<p class="elt_p1" data-aos="fade-up">We are committed to providing you with better products and services. If you have any inquiries, feel free to contact us through the channels below, and we will get back to you as soon as possible!</p>
				<div class="elt_p2" data-aos="fade-up">
					<img src="@/images/enimg/contact/icon_2.png">
					<p class="ep2_dt flex3">
						<span class="ep2_dian"></span>
						<span class="ep2_text">Email：export@jnc.cn</span>
					</p>
				</div>
				<div class="elt_p2" data-aos="fade-up">
					<img src="@/images/enimg/contact/icon_3.png">
					<p class="ep2_dt flex3">
						<span class="ep2_dian"></span>
						<span class="ep2_text">Address：No. 289 Chunyi Street, Mianzhu City, Sichuan Province</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			staticImg: this.$staticImg,
		}
	}
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.en_con {
	@font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	.en_con_pc {
		background-image: url("../../images/bgimg3.png");
		min-width: 950px;
		.bn_img {
			img {
				width: 100%;
				display: block;
			}
		}
		.ct_con {
			padding: 80px 260px;
			box-sizing: border-box;
			height: 460px;
			align-items: flex-start;
			background-image: url("../../images/contact/bgimg2.png");
			.cton_left {
				font-size: 40px;
				color: #d43236;
				font-weight: bold;
				border-bottom: 4px solid #d43236;
				padding-bottom: 5px;
			}
			.cton_right {
				margin-left: 114px;
				flex: 1;
				.crt_dx1 {
					color: #333;
					font-weight: bold;
					font-size: 20px;
					text-align: left;
					margin-top: 10px;
					margin-bottom: 80px;
				}
				.crt_dx2 {
					text-align: left;
					margin-bottom: 23px;
					img {
						width: 40px;
					}
					.crt_dx2_tx1 {
						width: 3px;
						height: 3px;
						border-radius: 3px;
						background-color: #333;
						margin: 0 10px 0 15px;
					}
					.crt_dx2_tx2 {
						font-size: 18px;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.en_con_pc {
			.ct_con {
				padding: 80px 180px;
				height: 500px;
				.cton_right {
					margin-left: 100px;
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.en_con_pc {
			.ct_con {
				padding: 80px 120px;
				height: 550px;
				.cton_left {
					font-size: 35px;
				}
				.cton_right {
					margin-left: 80px;
				}
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.en_con_pc {
			.ct_con {
				padding: 80px 120px;
				height: 600px;
				.cton_left {
					font-size: 30px;
				}
				.cton_right {
					margin-left: 60px;
				}
			}
		}
	}
	.en_con_phone {
		padding-top: 1.23rem;
		background-image: url("../../images/bgimg3.png");
		.bn_img {
			img {
				width: 100%;
				display: block;
			}
		}
        .lx_sty2{
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            span{
                color: #D43236;
                font-size: 0.65rem;
                border-bottom: 3px solid #D43236;
                padding-bottom: 0.28rem;
            }
        }
		.cont_text {
			padding: 0.73rem;
			text-align: left;
			.elt_p1 {
				color: #333;
				font-size: 0.4rem;
				line-height: 1.9;
				text-align: left;
                border-bottom: 1px solid #A4A4A4;
                padding-bottom: 1rem;
			}
			.elt_icon {
				width: 40px;
				margin-top: 0.8rem;
			}
			.elt_p2 {
				margin-top: 0.8rem;
				.ep2_dt {
					align-items: flex-start;
					flex-wrap: wrap;
					.ep2_dian {
						width: 4px;
						height: 4px;
						border-radius: 4px;
						background-color: #333;
						margin-top: 0.35rem;
					}
					.ep2_text {
						padding-left: 0.25rem;
						font-size: 0.41rem;
						font-weight: 600;
						flex: 1;
						line-height: 2;
					}
				}
			}
		}
	}
}
</style>